import {
    ADD_LOCATION_CRITERIA_REQUEST,
    ADD_LOCATION_CRITERIA_SUCCESS,
    ADD_LOCATION_CRITERIA_FAILURE,
} from '../constants/add_location_criteria.constants';

export const addLocationCriteriaRequest = (configId, config) => ({
    type: ADD_LOCATION_CRITERIA_REQUEST,
    configId,
    config,
});

export const addLocationCriteriaSuccess = addedLocationCriteria => ({
    type: ADD_LOCATION_CRITERIA_SUCCESS,
    addedLocationCriteria,
});

export const addLocationCriteriaFailure = error => ({
    type: ADD_LOCATION_CRITERIA_FAILURE,
    error,
});



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Lead-o-matic_location_create/redux/actions/add_location_criteria.actions.js